import { use, useEffect, useState } from 'react';
import {
  useGetAllCrmControlStatusesQuery,
  useGetLeadsEngagementsOverduesQuery,
} from '../../../../reduxToolkit/reducers/usersSlice';

export const useCrmControlData = () => {
  const [basicTab, setBasicTab] = useState('1');
  const [totalRows, setTotalRows] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(20);
  const [sort, setSort] = useState<'asc' | 'desc'>('desc');
  const [sortKey, setSortKey] = useState('violationDate');
  const [search, setSearch] = useState<string>('');
  const [statusFilter, setStatusFilter] = useState<{ id: number } | null>(null);
  const [debouncedSearch, setDebouncedSearch] = useState<string>('');
  const { data: crmControlStatuses } = useGetAllCrmControlStatusesQuery({});
  const { data: overdues } = useGetLeadsEngagementsOverduesQuery({
    page,
    perPage,
    sort,
    sortKey,
    search: debouncedSearch,
    statusFilter: statusFilter?.id ?? 0,
    skip: !statusFilter,
  });
  useEffect(() => {
    if (!statusFilter && crmControlStatuses?.length) {
      const defaultStatus = crmControlStatuses.find((status: { id: number; statusName: string }) => status.statusName === 'default');
      if (defaultStatus) {
        setStatusFilter({ id: defaultStatus.id });
      }
    }
  }, [statusFilter, crmControlStatuses]);

  useEffect(() => {
    if (overdues?.total) {
      setTotalRows(overdues.total);
      console.log('overdues', overdues);
    }
  }, [overdues]);
  useEffect(() => {
    const id = setTimeout(() => setDebouncedSearch(search.trim()), 400);
    return () => clearTimeout(id);
  }, [search]);
  return {
    overdues,
    crmControlStatuses,
    page,
    setPage,
    perPage,
    setPerPage,
    sort,
    setSort,
    sortKey,
    setSortKey,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    totalRows,
  };
};
